


export const formatUnixDate = (timestamp: number): string => {
  if (!timestamp) return "";
  const date = new Date(timestamp * 1000); // Unix в мілісекунди
  return date.toISOString().split("T")[0]; // "2026-05-01"
};

// або у форматі dd.mm.yyyy
export const formatUnixDateUA = (timestamp: number): string => {
  if (!timestamp) return "";
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString("uk-UA"); // "01.05.2026"
};

export const formatDateUA = (dateString: string): string => {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  
  return date.toLocaleDateString("uk-UA", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }); // "15.04.2026"
};

// або з часом
export const formatDateTimeUA = (dateString: string): string => {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  
  return date.toLocaleString("uk-UA", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }); // "15.04.2026, 00:00"
};

export const formatTimeOnly = (dateString: string): string => {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  
  return date.toLocaleTimeString("uk-UA", {
    hour: "2-digit",
    minute: "2-digit",
  }); // "00:00"
};